var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24Globe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M14.617 19.552c1.049-1.498 2.14-3.701 2.358-6.552h2.955c-.383 3.052-2.489 5.57-5.313 6.552zM4.069 13h2.992c.206 2.862 1.283 5.056 2.346 6.561-2.837-.977-4.953-3.5-5.338-6.561zm5.369-8.571C8.386 5.927 7.285 8.137 7.065 11H4.069c.386-3.072 2.517-5.603 5.369-6.571zM9.079 11c.306-3.272 1.98-5.55 2.947-6.603 1 1.071 2.648 3.328 2.933 6.603h-5.88zm.001 2h5.882c-.306 3.277-1.984 5.555-2.95 6.608-1.047-1.11-2.653-3.336-2.932-6.608zm10.85-2h-2.952c-.205-2.849-1.27-5.036-2.328-6.539 2.808.99 4.899 3.499 5.28 6.539zM22 12c0-5.504-4.471-9.982-9.972-9.998l-.013-.001L12 2C6.486 2 2 6.487 2 12c0 5.514 4.486 10 10 10l.015-.001.005.001.008-.002C17.529 21.983 22 17.504 22 12z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24Globe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_ globe.5c1780b5.svg";
export { ForwardRef as ReactComponent };